import { LANGUAGE_DISPLAY_NAMES } from '@shared/core/localized-defaults'
import { FormattedText, Typography } from 'src/modules/core/components'
import { buildExampleConfirmationSuffix } from 'src/modules/event/utils/message-builder'
import { buildPreviewCancelReply } from '../client-message-language-card.domain'
import type { MessageLanguagePreviewProps } from './message-language-preview.interface'
import classes from './message-language-preview.module.scss'

function PreviewBubble({ labelId, text, testId }: { labelId: string; text: string; testId: string }) {
  return (
    <div className={classes.item}>
      <Typography variant="span" className={classes.itemLabel}>
        <FormattedText id={labelId} />
      </Typography>
      <Typography variant="body" className={classes.bubble} data-testid={testId}>
        {text}
      </Typography>
    </div>
  )
}

export function MessageLanguagePreview({ language, businessName, confirmationsEnabled }: MessageLanguagePreviewProps) {
  return (
    <div className={classes.preview} data-testid="message-language-preview">
      <Typography variant="span" className={classes.title}>
        <FormattedText
          id="settings.messageLanguage.previewTitle"
          values={{ language: LANGUAGE_DISPLAY_NAMES[language].native }}
        />
      </Typography>
      <div className={classes.grid}>
        <PreviewBubble
          labelId="settings.messageLanguage.previewConfirmationLabel"
          text={`…${buildExampleConfirmationSuffix(language)}`}
          testId="message-language-preview-confirmation"
        />
        <PreviewBubble
          labelId="settings.messageLanguage.previewReplyLabel"
          text={buildPreviewCancelReply(language, businessName, confirmationsEnabled)}
          testId="message-language-preview-reply"
        />
      </div>
    </div>
  )
}
